<ion-header class="ion-no-border">
    <ion-toolbar mode="ios">
        <ion-buttons slot="start">
            <ion-button *ngIf="showBackButton" (click)="back()">
                <ion-icon class="header-back__icon--desktop ion-hide-md-down"
                          mode="ios"
                          name="chevron-back"></ion-icon>
                <ion-icon class="header-back__icon--mobile ion-hide-lg-up"
                          mode="ios"
                          name="arrow-back"></ion-icon>
                <ion-text class="ion-hide-md-down">Back</ion-text>
            </ion-button>
            <ion-back-button class="ion-hide-md-up"></ion-back-button>
            <ion-menu-button class="ion-hide-md-up" menu="left-menu"></ion-menu-button>
        </ion-buttons>
        <ion-img slot="start"
                 *ngIf="!showBackButton"
                 class="header__logo ion-hide-md-down"
                 [routerLink]="['/']"
                 src="{{ settings.logo }}"
                 alt="Organization Logo"></ion-img>

        <ion-title slot="end" class="ion-hide-md-down">
            <nav class="header__nav">
                <!-- Login -->
                <div class="header__nav-item" (click)="openLoginModal()">Login</div>

                <!-- Features -->
                <div class="header__nav-item">Features</div>

                <!-- FAQs -->
                <div class="header__nav-item">
                    <a href="https://faq.vesta.app" target="_blank">FAQs</a>
                </div>

                <!-- Contact -->
                <div class="header__nav-item ion-activatable">Contact</div>
            </nav>
        </ion-title>
        <ion-title class="ion-hide-md-up">
            <ion-img class="header__logo"
                     [routerLink]="['/']"
                     src="{{ settings.logo }}"
                     alt="Organization Logo"></ion-img>
        </ion-title>

<!--        <ion-buttons slot="end"></ion-buttons>-->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-progress-bar type="indeterminate" *ngIf="showProgressBar"></ion-progress-bar>
    <!-- Banner -->
    <div class="banner banner--{{ page }}"
         [ngClass]="{ 'ion-hide-lg-down': page === 'landing' }"
         *ngIf="!isSignupPage">{{ title }}</div>

    <div [ngClass]="{ 'inner-content': !isSignupPage }">
        <!-- Content Projection -->
        <ng-content></ng-content>

        <!-- Features -->
        <ion-grid class="features-grid ion-margin ion-padding" *ngIf="features.length !== 0">
            <ion-row class="features-grid__row ion-padding">
                <ion-col class="features-grid__col ion-padding"
                         size="12"
                         size-md="6"
                         size-lg="4"
                         *ngFor="let feature of features;">
                    <ion-card class="ion-text-center">
                        <span class="icon {{ feature.icon }}"></span>
                        <ion-card-header>
                            <ion-card-title color="primary">
                                {{ feature.title }}
                                <br>
                                <ion-text *ngIf="feature.comingSoon" color="danger">Coming soon</ion-text>
                            </ion-card-title>
                            <ion-card-subtitle>{{ feature.description }}</ion-card-subtitle>
                        </ion-card-header>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>

    <!-- Pricing Boxes -->
    <ion-grid class="pricing-grid" *ngIf="page === 'analysis' || page === 'contract' || page === 'marketing' || page === 'enterprise'" >
        <ion-row class="pricing-grid__row ion-justify-content-center">
            <ion-col class="pricing-grid__col"
                     size="12"
                     size-md="6"
                     size-lg="4">
                <ion-card>
                    <ion-card-header color="primary">
                        <ion-card-title class="ion-text-center">Add Users</ion-card-title>
                    </ion-card-header>

                    <ion-card-content class="ion-no-padding ion-padding-horizontal ion-margin">
                        Designed to support the needs of:

                        <ul class="ion-margin ion-padding-top ion-padding-start">
                            <li>Investors</li>
                            <li>Wholesalers</li>
                            <li>Real Estate Agents</li>
                        </ul>

                        <div class="card__footer ion-text-center">
                            <ion-text color="dark" class="price">{{ price | currency: 'USD': 'symbol':'1.0'  }}</ion-text>
                            <br>
                            <ion-text>per month, per user</ion-text>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>

            <ion-col class="pricing-grid__col"
                     size="12"
                     size-md="6"
                     size-lg="4">
                <ion-card class="ion-text-center">
                    <ion-card-header color="success">
                        <ion-card-title>Get Started!</ion-card-title>
                    </ion-card-header>

                    <ion-card-content class="ion-no-padding ion-padding-horizontal ion-margin">
                        Vesta provides access to a comprehensive set of features to streamline
                        real estate investment operations.

                        <ion-button color="success"
                                    shape="round"
                                    expand="block"
                                    strong="true"
                                    [routerLink]="['/organization-signup']"
                                    replaceUrl="true">
                            Sign Up Now!
                        </ion-button>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>

    <!-- Footer -->
    <ion-footer class="ion-no-border" *ngIf="isWebsite && !isSignupPage">
        <ion-grid class="ion-no-padding ion-margin-bottom">
            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding"
                         size="12"
                         size-sm="6"
                         offset-sm="3">
                    <ion-text color="primary">
                        <h4>Get Notified</h4>
                    </ion-text>
                    <ion-text>Get Notified about Product updates!</ion-text>

                    <form class="ion-margin" [action]="'https://realty.us19.list-manage.com/subscribe/post'" method="POST">
                        <input type="hidden" name="u" value="d08ac53a342f607e563aababc">
                        <input type="hidden" name="id" [value]="mailchimpId">
                        <ion-item class="vesta-searchbar ion-margin-vertical"
                                  mode="ios"
                                  lines="none">
                            <ion-icon slot="start" name="mail-outline"></ion-icon>
                            <ion-input id="email"
                                       type="email"
                                       name="email"
                                       placeholder="Enter your email address"
                                       aria-label="Email"
                                       mode="ios"
                                       inputmode="email"
                                       clear-input="true"
                                       autofocus="true"
                                       ngModel
                                       #email="ngModel"></ion-input>
                        </ion-item>

                        <ion-button type="submit"
                                    [disabled]="email.value === ''"
                                    shape="round"
                                    strong="true">
                            <ion-spinner name="bubbles" *ngIf="false"></ion-spinner>
                            {{ false ? '' : 'Get Notified' }}
                        </ion-button>
                    </form>
                </ion-col>
            </ion-row>
        </ion-grid>

        <div class="footer__trademark">Powered by Vesta, © {{ year }}</div>
<!--        <a [routerLink]="['/']">Disclaimer</a> - -->
        <a [routerLink]="['/terms-of-service']">Terms of Service</a> -
        <a [routerLink]="['/privacy']">Privacy Policy</a>
    </ion-footer>
</ion-content>
